/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.MultiDocUpload";
        const NAME_ATTRIBUTE = 'data-name';
        const CLEAR_ITEM_ATTRIBUTE = 'data-clearItem';
        const ROW_ID_ATTRIBUTE = 'data-rowid';
        const FILE_INPUT_PREFIX = "fileInput-";
        const FILE_NAME_PREFIX = "fileName-";
        const FILE_OK_PREFIX = "ok-";
        const FILE_UPLOAD_PREFIX = "upload-";
        const CLEAR_FILE_PREFIX = "clearUploadItemLabel-";
        const UPLOAD_FILE_PREFIX = "uploadButtonLabel-";
        const ITEM_CLASS = "upload-doc-type-item";
        const ITEM_ICONS_CLASS = "upload-doc-type-icons";
        const ITEM_INFO_CLASS = 'upload-doc-type-info';
        const ITEM_BUTTONS_CLASS = "upload-action-buttons";
        const SUCCESS_ICON_CLASS = "wpt-upload-success-icon";
        const INDICATOR_ICON_CLASS = "wpt-upload-indicator";
        const DOCTYPE_CLASS = 'upload-doc-type';
        const FILENAME_CLASS = 'upload-filename';
        class MultiDocUploadWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("MultiDocUploadWidgetTypeClass.createInstance()");
                    return new MultiDocUploadWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("MultiDocUploadWidgetTypeClass._storeHtml()");
                    MultiDocUploadWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MultiDocUploadWidgetTypeClass::constructor");
                if (MultiDocUploadWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (MultiDocUploadWidgetInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/MultiDocUpload/multi-doc-upload.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.MultiDocUploadWidgetTypeClass = MultiDocUploadWidgetTypeClass;
        class MultiDocUploadWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._docListDiv = null;
                this._docListList = null;
                this._collapseState = "Show";
                this._outerDiv = null;
                this._keywordsDiv = null;
                this._keywordsSubwidget = null;
                this._keywordsHeading = null;
                this._keywordsFooter = null;
                this._keywordsHolder = null;
                this._kwComponent = null;
                this._defaultDocTypeName = null;
                this._kwCompRequest = null;
                this._buttonDiv = null;
                this._uploadButton = null;
                this._clearButton = null;
                this._usesMaxHeight = null;
                this._maxHeightPx = null;
                this._resizeObserver = null;
                // Related document upload support
                this._relatedMode = false;
                this._masterDoc = null;
                this._serviceDocTypes = ['*'];
                this._exceptDocTypes = [];
                this._inheritedKeyNames = [];
                this._inheritedRecNames = [];
                this._allowInheritedOverride = false;
                this.presentInstance = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = MultiDocUploadWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._usesMaxHeight = false;
                    this._maxHeightPx = -1;
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._docListDiv = this._container.querySelector('#multiDocUploadDocTypesHolder');
                    this._docListList = this._docListDiv.querySelector('#multiDocUploadDocTypesList');
                    this._keywordsDiv = this._container.querySelector('#keywordsMultiDocUploadPlaceHolder');
                    this._keywordsSubwidget = this._keywordsDiv.querySelector('#keywordsSubwidget');
                    this._keywordsHeading = this._container.querySelector('#keywordsHeading');
                    this._keywordsFooter = this._container.querySelector('#keywordsFooter');
                    this._keywordsHolder = this._container.querySelector('#keywordsComponent');
                    this._buttonDiv = this._container.querySelector('#multiDocUploadButtons');
                    this._uploadButton = this._container.querySelector('#multiDocUploadBtn');
                    this._clearButton = this._container.querySelector('#multiDocUploadClearBtn');
                    let sizeTable = this._container.querySelector('.widget__size-target');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#multiDocUploadWidgetTitle'), 'STR_WPT_UPLOAD_DOCS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._uploadButton.querySelector('#multiDocUploadBtnLabel'), "STR_WPT_UPLOAD");
                    this._core.Helper.setElementTranslation(this._clearButton.querySelector('#multiDocUploadClearBtnLabel'), "STR_WPT_CLEAR");
                    this._core.Helper.setElementTranslation(this._container.querySelector('#multiDocUploadKeywordsTitle'), "STR_WPT_KEYWORDS");
                    this._core.Helper.setElementTranslation(this._container.querySelector('#multiDocUploadLoading'), 'STR_WPT_LOADING');
                    this._clearButton.addEventListener('click', this._clearAllItems);
                    this._uploadButton.addEventListener('click', this._uploadAllItems);
                    let maxHeight = window.getComputedStyle(sizeTable).maxHeight;
                    if (maxHeight != "none") {
                        // expecting max-height set in pixels
                        this._maxHeightPx = parseInt(maxHeight, 10);
                        this._usesMaxHeight = true;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using max-height: " + this._maxHeightPx);
                        }
                        if (window.ResizeObserver) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("browser supports ResizeObserver");
                            }
                            this._resizeObserver = new ResizeObserver(this._setKeywordsMaxHeight);
                        }
                        else {
                            console.warn("browser doesn't support ResizeObserver");
                        }
                    }
                    this._core.Functions.showElement(this._loader);
                    let config = this._config;
                    if (config.hasOwnProperty('CollapseState') && (config.CollapseState != null))
                        this._collapseState = config.CollapseState;
                    if (config.hasOwnProperty('RelatedMode') && (config.RelatedMode != null))
                        this._relatedMode = config.RelatedMode;
                    if (config.hasOwnProperty('ServiceDocTypes') && (config.ServiceDocTypes != null))
                        this._serviceDocTypes = config.ServiceDocTypes;
                    if (config.hasOwnProperty('ExceptDocTyps') && (config.ExceptDocTypes != null))
                        this._exceptDocTypes = config.ExceptDocTypes;
                    if (config.hasOwnProperty('InheritKeywords') && (config.InheritKeywords != null))
                        this._inheritedKeyNames = config.InheritKeywords;
                    if (config.hasOwnProperty('InheritKeywordRecords') && (config.InheritKeywordRecords != null))
                        this._inheritedRecNames = config.InheritKeywordRecords;
                    if (config.hasOwnProperty('AllowInheritedOverride') && (config.AllowInheritedOverride != null))
                        this._allowInheritedOverride = config.AllowInheritedOverride;
                    this._kwComponent = new Widgets.ComponentKeywordsUpload(this._core, this._keywordsHolder, this);
                    this._kwComponent.ErrorCallback = this._callErrorHandler;
                    this._kwComponent.FailCallback = this._callFailedHandler;
                    this._kwComponent.present();
                    this._core.OBHelper.LoadUploadDocumentTypes(this._presentUploadDocTypes);
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._presentUploadDocTypes = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._presentUploadDocTypes()");
                    let uploadDoctypes = this._core.OBHelper.UploadDocumentTypes;
                    this._docListList.innerHTML = "";
                    let fragment = document.createDocumentFragment();
                    this._core.Functions.hideElement(this._loader);
                    let obDoctypesLength = uploadDoctypes.length;
                    let uploadDocCount = 0;
                    let firstDoctype = null;
                    let conf = this._config;
                    if (conf.hasOwnProperty('DefaultUploadDocument') && conf.DefaultUploadDocument.length > 0) {
                        this._defaultDocTypeName = conf.DefaultUploadDocument;
                    }
                    let acceptFilter = this._core.Config.getApplicationConfig().DefaultAcceptFilter;
                    if (conf.hasOwnProperty('AcceptFilter') && conf.AcceptFilter.length > 0) {
                        acceptFilter = conf.AcceptFilter;
                    }
                    if (conf.hasOwnProperty('DocTypes') && conf.DocTypes.length > 0) {
                        let doctypesLength = conf.DocTypes.length;
                        for (let d = 0; d < doctypesLength; d++) {
                            let doctype = conf.DocTypes[d];
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at doctype: " + doctype);
                            }
                            for (let i = 0; i < obDoctypesLength; i++) {
                                let obDoctype = uploadDoctypes[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("checking with doctype: " + obDoctype.Name);
                                }
                                if (doctype == obDoctype.Name) {
                                    if (firstDoctype == null) {
                                        firstDoctype = obDoctype;
                                    }
                                    let item = document.createElement('li');
                                    fragment.appendChild(item);
                                    item.classList.add(ITEM_CLASS);
                                    item.setAttribute(NAME_ATTRIBUTE, obDoctype.Name);
                                    item.setAttribute(ROW_ID_ATTRIBUTE, "" + uploadDocCount);
                                    let iconDiv = document.createElement('div');
                                    item.appendChild(iconDiv);
                                    iconDiv.classList.add(ITEM_ICONS_CLASS);
                                    let okSpan = document.createElement('span');
                                    iconDiv.appendChild(okSpan);
                                    okSpan.id = FILE_OK_PREFIX + uploadDocCount;
                                    okSpan.classList.add("wpt-font", "wpt-font-icon_TickBold", SUCCESS_ICON_CLASS, WPTNamespace.HIDDEN_CLASS);
                                    let uploadSpan = document.createElement('span');
                                    iconDiv.appendChild(uploadSpan);
                                    uploadSpan.id = FILE_UPLOAD_PREFIX + uploadDocCount;
                                    uploadSpan.classList.add(INDICATOR_ICON_CLASS, WPTNamespace.HIDDEN_CLASS);
                                    this._core.Helper.getWptSpinner(this._fillUploadingIcon.bind(this, uploadSpan));
                                    let docDiv = document.createElement('div');
                                    item.appendChild(docDiv);
                                    docDiv.classList.add(ITEM_INFO_CLASS);
                                    let typeName = document.createElement('span');
                                    docDiv.appendChild(typeName);
                                    typeName.classList.add(DOCTYPE_CLASS);
                                    typeName.appendChild(document.createTextNode(this._core.OBHelper.getDocTypeAlias(obDoctype.Name, obDoctype.TranslatedName)));
                                    let fileName = document.createElement('span');
                                    docDiv.appendChild(fileName);
                                    fileName.id = FILE_NAME_PREFIX + uploadDocCount;
                                    fileName.classList.add(FILENAME_CLASS);
                                    let buttonDiv = document.createElement('div');
                                    item.appendChild(buttonDiv);
                                    buttonDiv.classList.add(ITEM_BUTTONS_CLASS);
                                    let clearButton = document.createElement('button');
                                    buttonDiv.appendChild(clearButton);
                                    clearButton.id = CLEAR_FILE_PREFIX + uploadDocCount;
                                    clearButton.setAttribute(CLEAR_ITEM_ATTRIBUTE, "" + uploadDocCount);
                                    clearButton.setAttribute('aria-label', 'clear file input');
                                    clearButton.classList.add('wpt-button', 'wpt-button--warn', 'wpt-font', 'wpt-font-icon_Close', WPTNamespace.HIDDEN_CLASS);
                                    clearButton.addEventListener('click', this._clearUploadItem);
                                    let uploadButton = document.createElement('button');
                                    buttonDiv.appendChild(uploadButton);
                                    uploadButton.id = UPLOAD_FILE_PREFIX + uploadDocCount;
                                    uploadButton.setAttribute(ROW_ID_ATTRIBUTE, "" + uploadDocCount);
                                    uploadButton.setAttribute('aria-label', 'select file');
                                    uploadButton.classList.add('wpt-button', 'wpt-button--primary', 'wpt-font', 'wpt-font-icon_Upload2');
                                    uploadButton.addEventListener('click', this._triggerFileSelection);
                                    let fileInput = document.createElement('input');
                                    buttonDiv.appendChild(fileInput);
                                    fileInput.id = FILE_INPUT_PREFIX + uploadDocCount;
                                    fileInput.type = "file";
                                    fileInput.accept = acceptFilter;
                                    fileInput.setAttribute(ROW_ID_ATTRIBUTE, "" + uploadDocCount);
                                    fileInput.classList.add("fileupload");
                                    fileInput.style.display = "none";
                                    fileInput.setAttribute('aria-label', 'file input');
                                    fileInput.addEventListener('change', this._fileChanged);
                                    uploadDocCount++;
                                    break;
                                }
                            }
                            this._docListList.appendChild(fragment);
                        }
                        if (uploadDocCount > 0) {
                            this._presentKeywords();
                            this._core.Functions.showElement(this._uploadButton);
                            this._core.Functions.showElement(this._clearButton);
                            // calculate max-height for keywords if necessary
                            if (this._usesMaxHeight) {
                                this._setKeywordsMaxHeight();
                                if (this._resizeObserver) {
                                    this._resizeObserver.observe(this._docListDiv);
                                    this._resizeObserver.observe(this._buttonDiv);
                                    this._resizeObserver.observe(this._keywordsDiv);
                                    this._resizeObserver.observe(this._keywordsSubwidget);
                                    this._resizeObserver.observe(this._keywordsHeading);
                                    this._resizeObserver.observe(this._keywordsFooter);
                                }
                            }
                        }
                        else {
                            this.addError(this._core.Locale.getTranslation('STR_WPT_NO_DOCTYPES_AVAILABLE'));
                        }
                    }
                    else {
                        this.addError(this._core.Locale.getTranslation('STR_WPT_NO_DOCTYPES_CONFIGURED'));
                        console.warn("Widgets.MultiDocUploadWidgetInstanceClass._presentUploadDocTypes: NO DOCTYPES");
                    }
                };
                this._fillUploadingIcon = (element, spinnerSvg) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._fillUploadingIcon()");
                    element.innerHTML = spinnerSvg;
                };
                this._presentKeywords = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._presentKeywords()");
                    // Need a typed configuration object
                    let conf = this._config;
                    // Hide our maps and jump out if no keywords
                    if (!conf.hasOwnProperty('Keywords') || (conf.Keywords == null) || (conf.Keywords.length == 0)) {
                        this._core.Functions.hideElement(this._keywordsDiv);
                        return;
                    }
                    // Default to suppressing doc date as this matches earlier configurations
                    // ExcludeGroups '*' excludes all MIKGs
                    this._kwCompRequest = {
                        DefaultDocType: this._defaultDocTypeName,
                        DocTypes: conf.DocTypes,
                        IncludeKeywords: [],
                        ExcludeKeywords: [],
                        ExcludeGroups: ['*'],
                        PrefillRecords: [],
                        SuppressDocDate: true
                    };
                    if (conf.hasOwnProperty('AllowDocDateInput') && (conf.AllowDocDateInput != null))
                        this._kwCompRequest.SuppressDocDate = !conf.AllowDocDateInput;
                    // May need to filter keywords
                    let includingAll = (conf.Keywords.indexOf('*') > -1);
                    if (!includingAll)
                        this._kwCompRequest.IncludeKeywords = JSON.parse(JSON.stringify(conf.Keywords));
                    let blockFilterApplied = false;
                    if (this._masterDoc) {
                        this._log.trace('_presentKeywords - Responding to master document being set - upload related');
                        let blockedKeys = [];
                        this._masterDoc.KeywordRecords.forEach(akwr => {
                            if (akwr.Type != 'MultiInstance') {
                                // SA/SI records get the keyword filter treatment
                                let prefillRecord = JSON.parse(JSON.stringify(akwr));
                                prefillRecord.Keywords = [];
                                for (let kCount = 0; kCount < akwr.Keywords.length; kCount++) {
                                    let kInstance = akwr.Keywords[kCount];
                                    if (!includingAll) {
                                        if (conf.Keywords.indexOf(kInstance.Name) > -1) {
                                            if (this._inheritedKeyNames.indexOf(kInstance.Name) > -1) {
                                                if (this._allowInheritedOverride)
                                                    prefillRecord.Keywords.push(kInstance);
                                                else {
                                                    blockedKeys.push(kInstance.Name);
                                                    blockFilterApplied = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        if (this._inheritedKeyNames.indexOf(kInstance.Name) > -1) {
                                            if (this._allowInheritedOverride)
                                                prefillRecord.Keywords.push(kInstance);
                                            else
                                                this._kwCompRequest.ExcludeKeywords.push(kInstance.Name);
                                        }
                                    }
                                }
                                if (prefillRecord.Keywords.length > 0)
                                    this._kwCompRequest.PrefillRecords.push(prefillRecord);
                            }
                        });
                        if (blockedKeys.length > 0) {
                            // Reset and repopulate
                            this._log.trace('repopulating keyword component requet');
                            this._kwCompRequest.IncludeKeywords = [];
                            conf.Keywords.forEach(kwName => {
                                if (blockedKeys.indexOf(kwName) == -1)
                                    this._kwCompRequest.IncludeKeywords.push(kwName);
                            });
                        }
                    }
                    // Need to check if we genuinely have a request or whether we've blocked everything and shouldn't show the dialog
                    if (!blockFilterApplied || (this._kwCompRequest.IncludeKeywords.length > 0)) {
                        this._kwComponent.makeRequest(this._kwCompRequest);
                        this._core.Functions.showElement(this._keywordsDiv);
                    }
                    else {
                        this._core.Functions.hideElement(this._keywordsDiv);
                    }
                };
                /**
                 * Calculates the according max-height for the keywords, based on the max-height of the widget.
                 */
                this._setKeywordsMaxHeight = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._setKeywordsMaxHeight()");
                    // remove 1px to avoid scroll bars without need
                    let calcMaxHeightPx = this._maxHeightPx - 1;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("starting with keywords height: " + calcMaxHeightPx);
                    }
                    // remove complete height of upload doc list
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._docListDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without doc list: " + calcMaxHeightPx);
                    }
                    // remove complete height of buttons
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._buttonDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without buttons: " + calcMaxHeightPx);
                    }
                    // remove margin height of keywords div
                    calcMaxHeightPx -= this._core.Functions.getElementMarginHeight(this._keywordsDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without div margin: " + calcMaxHeightPx);
                    }
                    // remove border height of keywords div
                    calcMaxHeightPx -= this._core.Functions.getElementBorderHeight(this._keywordsDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without div border: " + calcMaxHeightPx);
                    }
                    // remove padding height of keywords div
                    calcMaxHeightPx -= this._core.Functions.getElementPaddingHeight(this._keywordsDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without div padding: " + calcMaxHeightPx);
                    }
                    // remove margin height of keywords subwidget
                    calcMaxHeightPx -= this._core.Functions.getElementMarginHeight(this._keywordsSubwidget);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without subwidget margin: " + calcMaxHeightPx);
                    }
                    // remove border height of keywords subwidget
                    calcMaxHeightPx -= this._core.Functions.getElementBorderHeight(this._keywordsSubwidget);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without subwidget border: " + calcMaxHeightPx);
                    }
                    // remove padding height of keywords subwidget
                    calcMaxHeightPx -= this._core.Functions.getElementPaddingHeight(this._keywordsSubwidget);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without subwidget padding: " + calcMaxHeightPx);
                    }
                    // remove complete height of keywords heading
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._keywordsHeading);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without heading: " + calcMaxHeightPx);
                    }
                    // remove complete height of keywords footer
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._keywordsFooter);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without footer: " + calcMaxHeightPx);
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got keywords height: " + calcMaxHeightPx);
                    }
                    if (calcMaxHeightPx > 0) {
                        // set the calculated max-height on the keywords
                        this._keywordsHolder.style.maxHeight = calcMaxHeightPx + "px";
                    }
                };
                this._triggerFileSelection = (event) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._triggerFileSelection()");
                    let clickedItem = event.currentTarget;
                    let rowId = clickedItem.getAttribute(ROW_ID_ATTRIBUTE);
                    let fileInput = clickedItem.parentElement.querySelector('#' + FILE_INPUT_PREFIX + rowId);
                    fileInput.click();
                };
                this._fileChanged = (event) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._fileChanged()");
                    let changedItem = event.currentTarget;
                    let rowid = changedItem.getAttribute(ROW_ID_ATTRIBUTE);
                    let fileName = changedItem.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got filename: " + fileName);
                    }
                    let fileSize = changedItem.files[0].size;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got filesize: " + fileSize);
                    }
                    let extension = fileName.substring(fileName.lastIndexOf('.') + 1);
                    if (this._core.Helper.validateFileFormat(extension)) {
                        if (this._core.Helper.validateFileSize(fileSize)) {
                            let clearButton = this._docListList.querySelector("#" + CLEAR_FILE_PREFIX + rowid);
                            this._core.Functions.showElement(clearButton);
                            let uploadButton = this._docListList.querySelector("#" + UPLOAD_FILE_PREFIX + rowid);
                            this._core.Functions.hideElement(uploadButton);
                            let fileNameSpan = this._docListList.querySelector("#" + FILE_NAME_PREFIX + rowid);
                            fileNameSpan.innerHTML = "";
                            let lineBreak = document.createElement('br');
                            fileNameSpan.appendChild(lineBreak);
                            let displayName = fileName.split(/(\\|\/)/g).pop();
                            fileNameSpan.appendChild(document.createTextNode(displayName));
                        }
                        else {
                            this._clearFileItem(rowid);
                            this._core.Helper.presentWarningModal("STR_WPT_UPLOAD_SIZE_EXCEEDED");
                        }
                    }
                    else {
                        this._clearFileItem(rowid);
                        this._core.Helper.presentWarningModal("STR_WPT_UPLOAD_INVALID_FORMAT");
                    }
                    if (!this._resizeObserver) {
                        this._setKeywordsMaxHeight();
                    }
                };
                this._clearUploadItem = (event) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._clearUploadItem()");
                    let clickedItem = event.currentTarget;
                    let rowid = clickedItem.getAttribute(CLEAR_ITEM_ATTRIBUTE);
                    this._core.Functions.hideElement(clickedItem);
                    let uploadButton = this._docListList.querySelector("#" + UPLOAD_FILE_PREFIX + rowid);
                    this._core.Functions.showElement(uploadButton);
                    this._clearFileItem(rowid);
                    if (!this._resizeObserver) {
                        this._setKeywordsMaxHeight();
                    }
                };
                this._clearFileItem = (rowid) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._clearFileItem()");
                    let changedItem = this._docListList.querySelector("#" + FILE_INPUT_PREFIX + rowid);
                    let tempItem = changedItem.cloneNode(true);
                    tempItem.value = '';
                    tempItem.addEventListener('change', this._fileChanged);
                    changedItem.replaceWith(tempItem);
                    let fileName = this._docListList.querySelector("#" + FILE_NAME_PREFIX + rowid);
                    fileName.innerHTML = "";
                    let fileOk = this._docListList.querySelector("#" + FILE_OK_PREFIX + rowid);
                    this._core.Functions.hideElement(fileOk);
                    let fileUpload = this._docListList.querySelector("#" + FILE_UPLOAD_PREFIX + rowid);
                    this._core.Functions.hideElement(fileUpload);
                };
                this._clearAllItems = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._clearAllItems()");
                    let items = this._docListList.querySelectorAll('.' + ITEM_CLASS);
                    items.forEach(element => {
                        let item = element;
                        let rowId = item.getAttribute(ROW_ID_ATTRIBUTE);
                        let clearLabel = item.querySelector("#" + CLEAR_FILE_PREFIX + rowId);
                        this._core.Functions.hideElement(clearLabel);
                        let uploadLabel = item.querySelector("#" + UPLOAD_FILE_PREFIX + rowId);
                        this._core.Functions.showElement(uploadLabel);
                        this._clearFileItem("" + rowId);
                    });
                    if (this._kwCompRequest)
                        this._kwComponent.makeRequest(this._kwCompRequest);
                    this._core.Functions.showElement(this._uploadButton);
                };
                this._uploadAllItems = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._uploadAllItems()");
                    if (!this._kwComponent.Valid) {
                        this._core.Helper.presentWarningModal('STR_WPT_REQUIRED_ARCHIVE_KEYS_MISSING');
                        return;
                    }
                    // TODO: let keyword component check form validity and get keyword data
                    let inputKeywordRecords = [];
                    let docDate = null;
                    if (this._kwCompRequest != null) {
                        inputKeywordRecords = this._kwComponent.KeywordRecords;
                        let dateKey = this._kwComponent.Properties.find(prop => (prop.Name == '>>DocumentDate'));
                        if (dateKey)
                            docDate = dateKey.Value;
                    }
                    let items = this._docListList.querySelectorAll('.' + ITEM_CLASS);
                    items.forEach(element => {
                        let item = element;
                        let rowId = item.getAttribute(ROW_ID_ATTRIBUTE);
                        let docTypeName = item.getAttribute(NAME_ATTRIBUTE);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at doctype: " + docTypeName);
                        }
                        let fileInput = item.querySelector("#" + FILE_INPUT_PREFIX + rowId);
                        let fileName = fileInput.value;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at file: " + fileName);
                        }
                        if (fileName) {
                            this._core.Functions.hideElement(this._uploadButton);
                            let file = fileInput.files[0];
                            let fileType = fileName.substring(fileName.lastIndexOf('.') + 1);
                            let requestUpload = {
                                KeywordRecords: this._mergeInheritedKeys(docTypeName, inputKeywordRecords),
                                DocType: docTypeName,
                                FileType: fileType,
                                Date: (docDate) ? docDate : null
                            };
                            let request = JSON.stringify(requestUpload);
                            let formData = new FormData();
                            formData.append("request", request);
                            formData.append('file', file);
                            let headers = {
                                "Content-Type": "multipart/form-data"
                            };
                            this._core.Loader.genericServiceCallWithData('/Upload.svc/rest/MultiPartUploadDocument', formData, this._finishedUpload, headers, this._errorUpload, this._failedUpload);
                            let fileUpload = item.querySelector("#" + FILE_UPLOAD_PREFIX + rowId);
                            this._core.Functions.showElement(fileUpload);
                        }
                    });
                };
                this._finishedUpload = (docData) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._finishedUpload()");
                    if (docData.hasOwnProperty('MultiPartUploadDocumentResult') && docData.MultiPartUploadDocumentResult.hasOwnProperty('Documents') && docData.MultiPartUploadDocumentResult.Documents != null) {
                        let docLength = docData.MultiPartUploadDocumentResult.Documents.length;
                        for (let i = 0; i < docLength; i++) {
                            let doc = docData.MultiPartUploadDocumentResult.Documents[i];
                            let docName = doc.Name;
                            let docTypeName = doc.DocType.Name;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("finished upload of: " + docTypeName + " - " + docName);
                            }
                            let items = this._docListList.querySelectorAll('.' + ITEM_CLASS);
                            items.forEach(element => {
                                let item = element;
                                let rowId = item.getAttribute(ROW_ID_ATTRIBUTE);
                                if (docTypeName === item.getAttribute(NAME_ATTRIBUTE)) {
                                    let uploadSpan = item.querySelector('#' + FILE_UPLOAD_PREFIX + rowId);
                                    this._core.Functions.hideElement(uploadSpan);
                                    let okSpan = item.querySelector('#' + FILE_OK_PREFIX + rowId);
                                    this._core.Functions.showElement(okSpan);
                                }
                            });
                            // Tell everyone what we've done
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_UPLOADED);
                            navEvent.ActivationID = doc.ItemNum;
                            navEvent.PrimaryContext = doc;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                    else {
                        console.warn("missing properties in response");
                    }
                };
                this._errorUpload = (url, status, text) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._errorUpload()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_UPLOAD_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_UPLOAD", "STR_WPT_ERROR", msgBody);
                };
                this._failedUpload = (docData) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._failedUpload()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_UPLOAD_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (docData.hasOwnProperty('MultiPartUploadDocumentResult') && docData.MultiPartUploadDocumentResult.hasOwnProperty('Connection') && docData.MultiPartUploadDocumentResult.Connection.hasOwnProperty('Message')) {
                        errorMsg += docData.MultiPartUploadDocumentResult.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._mergeInheritedKeys = (docTypeName, userKeyRecords) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._mergeInheritedKeys()");
                    // Just make sure we haven't been called for no reason, or with nothing to do
                    if (!this._relatedMode || !this._masterDoc || ((this._inheritedKeyNames.length == 0) && (this._inheritedRecNames.length == 0)))
                        return userKeyRecords;
                    // If we get here, we need something to return and a variety of configuration objects
                    let targetDT = this._core.OBHelper.UploadDocumentTypeMap[docTypeName];
                    let mergedKeyRecords = JSON.parse(JSON.stringify(userKeyRecords));
                    // Merge/inherit standalone items
                    let standalone = mergedKeyRecords.find(kwr => kwr.Type == 'StandAlone');
                    if ((this._inheritedKeyNames.length > 0) && (!standalone)) {
                        standalone = { Id: 0, Name: 'Standalone Keywords', Type: 'StandAlone', Keywords: [] };
                        mergedKeyRecords.push(standalone);
                    }
                    this._inheritedKeyNames.forEach(keyName => {
                        let keyValid = false;
                        targetDT.KeywordRecords.forEach(targetKWRT => {
                            if ((targetKWRT.Type == 'StandAlone') || (targetKWRT.Type == 'SingleInstance')) {
                                targetKWRT.KeywordTypes.forEach(targetKWT => {
                                    if (targetKWT.Name == keyName)
                                        keyValid = true;
                                });
                            }
                        });
                        if (keyValid) {
                            this._core.OBHelper.GetAllKeywordValues(this._masterDoc, keyName, false).forEach(keyValue => {
                                standalone.Keywords.push({ Id: 0, Name: keyName, Value: keyValue });
                            });
                        }
                    });
                    // Merge/inherit MIKGS
                    this._inheritedRecNames.forEach(recName => {
                        let recType = targetDT.KeywordRecords.find(targetKWRT => targetKWRT.Name == recName);
                        if (recType) {
                            this._masterDoc.KeywordRecords.forEach(kwr => {
                                if (kwr.Name == recName)
                                    mergedKeyRecords.push(kwr);
                            });
                        }
                    });
                    return mergedKeyRecords;
                };
                this._lockInterfaceByDocType = () => {
                    this._log.info("MultiDocUploadWidgetInstanceClass._lockInterfaceByDocType()");
                    // Check if we should service a particualr document in the master document record and lock interface (and hide) if not
                    let dtName = '*';
                    if (this._masterDoc && this._masterDoc.hasOwnProperty('DocType') && this._masterDoc.DocType)
                        dtName = this._masterDoc.DocType.Name;
                    if (this.CanServiceDocType(dtName)) {
                        if (this._collapseState == "Stealth")
                            this._core.Functions.showElement(this._outerDiv);
                        this._presentKeywords();
                        return true;
                    }
                    else {
                        if (this._collapseState == "Stealth")
                            this._core.Functions.hideElement(this._outerDiv);
                        return false;
                    }
                };
                this.CanServiceDocType = (dtName) => {
                    this._log.info("MultiDocUploadWidgetInstanceClass.CanServiceDocType()");
                    if (((this._serviceDocTypes.indexOf('*') > -1) || (this._serviceDocTypes.indexOf(dtName) > -1)) && (this._exceptDocTypes.indexOf(dtName) == -1))
                        return true;
                    else
                        return false;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MultiDocUploadWidgetInstanceClass::constructor");
                this._capabilites.push('MultiDocUpload', 'UploadRelated');
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("MultiDocUploadWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.RELATED_UPLOAD_REQUEST:
                        if (this._relatedMode) {
                            // Need to check if we are actually responding to the current document
                            this._masterDoc = this._core.Context.getDocumentFromSlot(WPTNamespace.Utilities.RELATED_UPLOAD_SLOT_KEY);
                            this._lockInterfaceByDocType();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        if (this._relatedMode) {
                            this._masterDoc = null;
                            if (this._collapseState == "Stealth")
                                this._core.Functions.hideElement(this._outerDiv);
                        }
                        break;
                }
            }
        }
        MultiDocUploadWidgetInstanceClass.HtmlData = null;
        Widgets.MultiDocUploadWidgetInstanceClass = MultiDocUploadWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
